import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCard, MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../shared/shared.module';
import { HomeSecretaryComponent } from './pages/home/home-secretary.component';
import { SecretariesRoutingModule } from './secretaries-routing.module';
import { MatError, MatFormFieldControl, MatFormFieldModule } from '@angular/material/form-field';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { ProfileComponent } from './pages/profile/profile.component';
import { ScheduleStatusComponent } from './pages/schedule/status/schedule-status.component';
import { ScheduleComponent } from './pages/schedule/schedule.component';
import { OrganizationSecretariesComponent } from './pages/organization/organization.component';
import { OrganizationSecretariesLinkComponent } from './pages/organization/bond/organization-link.component';
import { OrganizationSecretariesDetailsComponent } from './pages/organization/details/organization-details.component';
import { PractionerSecretaryComponent } from './pages/practioner/practioner.component';
import { PractionerSecretaryLinkComponent } from './pages/practioner/bond/practioner-registration.component';
import { PractionerSecretaryDetailsComponent } from './pages/practioner/details/practitioner-details.component';
import { ScheduleAppointmentSecretaryComponent } from './pages/schedule/appointment/schedule-appointment.component';
import { ScheduleRegistrationSecretaryComponent } from './pages/schedule/registration/schedule-registration.component';
import { ScheduleSecretaryEditStatusComponent } from './pages/schedule/status/edit-status/schedule-edit-status.component';
import { ScheduleSecretaryDetailsComponent } from './pages/schedule/status/details/schedule-details.component';
import { ScheduleSecretaryProcedureComponent } from './pages/schedule/procedure/schedule-procedure.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SecretaryRegistrationComponent } from './components/secretary-registration/secretary-registration.component';
import { SecretaryAddressFormComponent } from './components/address-form/secretary-address-form.component';
import { SecretaryQualificationFormComponent } from './components/qualification-form/secretary-qualification-form.component';
import { MatSliderModule } from '@angular/material/slider';
import { SecretaryDashboardComponent } from './pages/dashboard/dashboard.component';
import { ConfirmConvenioComponent } from './components/confirm-convenio/confirm-convenio.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ProcedureBySpecialistComponent } from './pages/schedule/procedure-by-specialist/procedure-by-specialist.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { SecretaryBankAccountComponent } from './components/secretary-bank-account/secretary-bank-account.component';
import {  MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@NgModule({
  declarations: [
    HomeSecretaryComponent,
    ProfileComponent,
    SecretaryRegistrationComponent,
    SecretaryAddressFormComponent,
    SecretaryQualificationFormComponent,
    ScheduleStatusComponent,
    ScheduleComponent,
    OrganizationSecretariesComponent,
    OrganizationSecretariesLinkComponent,
    OrganizationSecretariesDetailsComponent,
    PractionerSecretaryComponent,
    ScheduleAppointmentSecretaryComponent,
    SecretaryDashboardComponent,
    PractionerSecretaryLinkComponent,
    PractionerSecretaryDetailsComponent,
    ScheduleRegistrationSecretaryComponent,
    ScheduleSecretaryEditStatusComponent,
    ScheduleSecretaryDetailsComponent,
    ScheduleSecretaryProcedureComponent,
    ConfirmConvenioComponent,
    ProcedureBySpecialistComponent,
    SecretaryBankAccountComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    FormsModule,
    CommonModule,
    MatFormFieldModule,
    SecretariesRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    MatTabsModule,
    MatIconModule,
    MatChipsModule,
    MatSelectModule,
    MatToolbarModule,
    MatDialogModule,
    MatDatepickerModule,
    MatSnackBarModule,
    MatSliderModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    MatAutocompleteModule
  ],
  exports: [
    OrganizationSecretariesLinkComponent,
    SecretaryRegistrationComponent,
    SecretaryAddressFormComponent,
    OrganizationSecretariesDetailsComponent,
    PractionerSecretaryDetailsComponent,
    PractionerSecretaryLinkComponent,
    ScheduleRegistrationSecretaryComponent,
    ScheduleSecretaryEditStatusComponent,
    ScheduleSecretaryDetailsComponent,
  ],
})
export class SecretariesModule {}
